// Global
import React from 'react';
// Local
import EmailBox from './EmailBox';
import { Data } from '@generated/Foundation.GMI.model';
import { useSiteSettings } from 'lib/hooks/useSiteSettings';

export const Default = () => {
  const siteSettings = useSiteSettings();

  // Get email code from settings if available
  const emailSettings = siteSettings?.emailSettings as Data.Settings.EmailSettings;
  const emailCode = emailSettings?.fields?.emailCode?.value;
  // Prepare email box props with only email code and page URL
  const emailBoxProps = {
    emailName: emailCode,
  };

  return <EmailBox {...emailBoxProps} />;
};
